import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { baseUrl } from '../../../../../config/route-entry-point';
import { formatMoney } from '../../../../../modules/shared/format';
import { getCurrencyIcon } from '../../../../../../shared/js/get-currency-icon';
import find from 'lodash/find';
import classname from 'classname';
import Circle from './components/circle';
import SeveupHint from './components/seveupHint';

const propTypes = {
	intl: PropTypes.func,
	userData: PropTypes.object,
	lists: PropTypes.object,
	saveInLocalStorage: PropTypes.func
};

const Main = (props) => {
	const { userData, lists, intl, saveInLocalStorage} = props;
	const { general, balances, activeBalance } = userData;
	const defaultBalance = balances && find(balances, b => b.currency == activeBalance) || balances[0];
	const userId = general.id;
	const balancesList = getBalancesList(
		userId,
		balances,
		activeBalance,
		saveInLocalStorage,
		intl
	);
	const showAddCurrency = balances.length < lists['available-currencies'].length;

	return (
		<div className="user-balances-control">
			{ defaultBalance ? (
				<div className="balance dropdown">
					<div className="dropdown__head">
						<span className="balance-title">
							<span>{ intl('Ваш') }</span> <span>{ intl('баланс') }</span>
						</span>
						<span className="balance-amount font-proxima-nova-regular">
							{ formatMoney(defaultBalance.amount, true) }
							<span className="currency"> { getCurrencyIcon(defaultBalance.currency) }</span>
						</span>
						<div className="dropdown_suggests">
							{ balancesList }
							{showAddCurrency && (
								<div className="dropdown_suggests-item clearfix add_currency_item">
									<div className="dropdown_suggests-item_group amount-group">
										<Link className="add_currency" to={baseUrl('profile/')}>
											{ intl('Добавить валюту')}<span className="icon-plus"/>
										</Link>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className='points-balance'>
						<div>
							<div className='points-balance__title'>QUID</div>
							<div className='points-balance__amount'>
								{Math.round(general.contest_points * 100)/100}
							</div>
						</div>
						<Circle contest_points = {general.contest_points} />
					</div>
					<div className="points-balance">
						<SeveupHint intl={intl} contest_points = {general.contest_points} />
					</div>
				</div>
			) : (
				<Link to={baseUrl('profile/')} className="no-balance">
					<span className="no-balance__wrap">
						<span className="no-balance__text">{ intl('Добавить валюту')}</span>
					</span>
				</Link>
			)}
		</div>
	);
};

const getBalancesList = (
	userId,
	balances,
	activeBalance,
	saveInLocalStorage,
	intl
) => {
	return balances.map(balance => {
		const { currency } = balance;
		const className = classname({
			'dropdown_suggests-item': true,
			'clearfix': true,
			'active': currency == activeBalance
		});
		return (
			<div key={currency} className={className} onClick={e => {
				saveInLocalStorage('activeBalance', JSON.stringify({userId, currency: balance.currency}));
				const list = document.body.querySelector('.dropdown_suggests');
				list.style.display = 'none';
				setTimeout(() => {list.style.display = 'block';}, 500);
			}}>
				<div className="left-part">
					<div className="dropdown_suggests-item_group amount-group clearfix">
						<div className={classname(
							'dropdown_suggests-item_value balance_value font-proxima-nova-semibold'
						)}>{ formatMoney(balance.amount, true) }</div>
						<div className="dropdown_suggests-item_key">{ getCurrencyIcon(currency) }</div>
					</div>
					<div className="dropdown_suggests-item_group hold-group clearfix">
						<div className="dropdown_suggests-item_value hold_value">{ formatMoney(balance.hold_amount, true) }</div>
						<div className="dropdown_suggests-item_key">{ intl('На холде') }</div>
					</div>
				</div>
			</div>
		);
	});
};

Main.propTypes = propTypes;

export default connect(
	state => ({
		userData: state.app.userData,
		lists: state.app.lists,
		router: state.routing.locationBeforeTransitions
	})
)(Main);


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/sidebar/balances/main.js